import { render, staticRenderFns } from "./hrmine-chat.vue?vue&type=template&id=1283803c&scoped=true"
import script from "./hrmine-chat.vue?vue&type=script&lang=js"
export * from "./hrmine-chat.vue?vue&type=script&lang=js"
import style0 from "./hrmine-chat.vue?vue&type=style&index=0&id=1283803c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1283803c",
  null
  
)

export default component.exports